// Library Imports
import React from "react";
import Typography from "@mui/material/Typography";
import styled from "@mui/material/styles/styled";
const CustomPrimaryTextWrapper = styled(Typography)((data) => {
    return {
        display: "flex",
        justifyContent: "space-between",
        "& span": {
            padding: "0.5vw 0",
            "&:first-of-type": {
                width: "65%",
                // whiteSpace: "nowrap",
                // textOverflow: "ellipsis",
                // overflow: "hidden",
            },
        },
    };
});
const PrimaryText = (props) => {
    const { label, labelRight } = props;
    if (!label)
        return null;
    return (React.createElement(CustomPrimaryTextWrapper, { className: "label-warapper" },
        React.createElement("span", { title: label }, label),
        labelRight ? React.createElement("span", { className: "label-right" }, labelRight) : null));
};
export default React.memo(PrimaryText);
